module.exports = __webpack_public_path__ + "media/images/new_home/timeline-bg-f00252c8f4c4dea4c78379d565d7860e.svg";